import React from "react";
import { useEffect, useState,useRef  } from "react";
import "bootstrap/dist/css/bootstrap.min.css";
import * as actionUrl from "../../store/actions";
import "../../assets/css/englishAuction.css";
import { useSelector } from "react-redux";
import { useDispatch } from "react-redux";

const usertypeId = parseInt(atob(localStorage.getItem("argument3")));
const EnglishTable = ({
  userWiseViewEnglishAuctionData,
  handleChange,
  fixedColumns,
  handleButton,
  handleSelectRow,
  selectedRows,
  handleMarketDepth,
}) => {
  let fixedColumnsOn = true;
  const dispatch = useDispatch()
  const auctionDetailId =
  window.location.pathname &&
  window.location.pathname.split("/") &&
  window.location.pathname.split("/")[2]
    ? atob(
        window.location.pathname &&
          window.location.pathname.split("/") &&
          window.location.pathname.split("/")[2]
      )
    : "";
  const userId =
    window.location.pathname &&
    window.location.pathname.split("/") &&
    window.location.pathname.split("/")[3]
      ? atob(
          window.location.pathname &&
            window.location.pathname.split("/") &&
            window.location.pathname.split("/")[3]
        )
      : "";  
  const auctionDataColumnDetails =
    userWiseViewEnglishAuctionData?.columnDetails;
  const auctionDataLiveBidDetails =
    userWiseViewEnglishAuctionData?.liveBidDetails;
  const sortedData =
    auctionDataLiveBidDetails != [] && auctionDataColumnDetails != undefined
      ? auctionDataColumnDetails.sort((a, b) => a.sortOrder - b.sortOrder)
      : [];
  const [columns, setColumns] = useState(sortedData);

  useEffect(() => {
    if (
      JSON.stringify(columns) !== JSON.stringify(userWiseViewEnglishAuctionData?.columnDetails)
    ) {
      setColumns(userWiseViewEnglishAuctionData?.columnDetails);
    }
  }, [userWiseViewEnglishAuctionData, columns]); 

  // useEffect(() => {
  //   let payloadData = {
  //     auctionDetailId: auctionDetailId,
  //     userLoginId: userId,
  //     catalogColumnConfigurationDetails: columns,
  //   };
  //   dispatch(actionUrl.addCatalogColumnConfigRequest(payloadData));
  // },[columns])
  // Function to handle drag start
  const handleDragStart = (e, index) => {
    e.dataTransfer.setData("index", index);
  };
  const tableRef = useRef(null);
  // Function to handle drag over
  const handleDragOver = (e) => {
    e.preventDefault();
  };
  useEffect(() => {
    const handleKeyDown = (event) => {
      if (event.key !== "ArrowRight" && event.key !== "ArrowLeft") return;

      event.preventDefault(); // Prevent page scrolling

      // Select all enabled inputs & buttons
      const focusableElements = Array.from(
        tableRef.current.querySelectorAll("input:not([disabled]), button:not([disabled])")
      );
      const currentIndex = focusableElements.indexOf(document.activeElement);

      if (event.key === "ArrowRight") {
        // Move forward (like Tab), skipping disabled elements
        let nextIndex = currentIndex + 1;
        while (nextIndex < focusableElements.length && focusableElements[nextIndex].disabled) {
          nextIndex++;
        }
        if (nextIndex < focusableElements.length) {
          focusableElements[nextIndex].focus();
        }
      } else if (event.key === "ArrowLeft") {
        // Move backward (like Shift + Tab), skipping disabled elements
        let prevIndex = currentIndex - 1;
        while (prevIndex >= 0 && focusableElements[prevIndex].disabled) {
          prevIndex--;
        }
        if (prevIndex >= 0) {
          focusableElements[prevIndex].focus();
        }
      }
    };

    document.addEventListener("keydown", handleKeyDown);
    return () => document.removeEventListener("keydown", handleKeyDown);
  }, []);
  
// Function to handle drop
const handleDrop = (e, dropIndex) => {
  e.preventDefault();
  const dragIndex = parseInt(e.dataTransfer.getData("index"));

  if (!isNaN(dragIndex)) {
      // Create a copy of the columns to perform the drag & drop
      const newColumns = [...columns];

      // Get the dragged column
      const draggedColumn = newColumns[dragIndex];

      // Remove dragged column and place it at the dropIndex
      newColumns.splice(dragIndex, 1);
      newColumns.splice(dropIndex, 0, draggedColumn);

      // Update sortOrder
      const updatedColumns = [...newColumns];

      if (dragIndex < dropIndex) {
        updatedColumns.forEach((column, index) => {
            if (index === dropIndex) {
                column.sortOrder = index + 1;
            } else if (index === dragIndex) {
              column.sortOrder = index + 1;
            } else if (index > dragIndex && index <= dropIndex) {
                column.sortOrder = index + 1;
            } 
        });
    } else { // If dragging the item after the target (dragIndex > dropIndex), we shift sort orders up
        updatedColumns.forEach((column, index) => {
            if (index === dropIndex) {
                column.sortOrder = index + 1;
            } else if (index === dragIndex) {
              column.sortOrder = index + 1;
            } else if (index < dragIndex && index >= dropIndex) {
                column.sortOrder = index + 1
            }
        });
    }

      // Now, update the auctionDataLiveBidDetails to reflect the column order change
      auctionDataLiveBidDetails &&
          auctionDataLiveBidDetails.map((row) => {
              let dragData = row.columnDetails[dragIndex];
              row.columnDetails.splice(dragIndex, 1);
              row.columnDetails.splice(dropIndex, 0, dragData);
          });

      // If needed, you can dispatch your updated columns here:
      setTimeout(() => {
          const payloadData = {
              auctionDetailId: auctionDetailId,
              userLoginId: userId,
              catalogColumnConfigurationDetails: updatedColumns, // Use the updated columns with correct sortOrder
          };

          // Dispatch the API request to update the catalog column config
          dispatch(actionUrl.addCatalogColumnConfigRequest(payloadData));
      }, 1000);
  }
};
  
  const moduleList = useSelector(
    (state) => state?.ModuleReducer?.data?.responseData
  );

  const [rightsIdData, setRightsIdData] = useState([]);

  if (
    moduleList !== null &&
    moduleList !== undefined &&
    rightsIdData?.length == 0
  ) {
    setRightsIdData(
      moduleList?.auctionCentersList
        ?.map((auctionCenters) => auctionCenters.modulesDtoList)
        ?.at(0)
        ?.filter((modulesDto) => modulesDto.moduleid == 3)
        ?.at(0)
        ?.linksDtoList?.filter((linksDto) => linksDto.linkId == 52)
        ?.at(0)?.rightIds
    );
  }
  let status = "";
  let statusColor = "";
  return (
    <table id="example" ref={tableRef} class="stripe- row-border order-column table ">
      <thead>
        <tr>
          {columns &&
            columns.map((column, index) =>
              column.isShown == 1 ? (
                column.isLocked == 1 ? (
                  <th>{column.columnName}</th>
                ) : (
                  <th
                    key={index}
                    draggable
                    onDragStart={(e) => handleDragStart(e, index)}
                    onDragOver={handleDragOver}
                    onDrop={(e) => handleDrop(e, index)}
                  >
                    {column.columnName}
                  </th>
                )
              ) : (
                ""
              )
            )}
        </tr>
      </thead>

      {auctionDataLiveBidDetails &&
        auctionDataLiveBidDetails.map((row, index) => (
          <tr key={index}>
            {row.columnDetails &&
              row.columnDetails.map((item, i) =>
                columns[i].isShown == 1 ? (
                  <td
                    className={
                      selectedRows.includes(row.auctionItemDetailId)
                        ? "selectedRowColor1"
                        : item.columnColor
                    }
                    key={i}
                  >
                    {item.columnTypeId === 15 ?                    
                    (
                      <p
                        onClick={() => handleSelectRow(row.auctionItemDetailId)}
                        sahil={statusColor=item.columnColor}
                      >
                        {status = item.columnValue}
                      </p>
                    ) : item.columnTypeId === 31 ? (
                      <input
                        type="number"
                        id={row.auctionItemDetailId}
                        onChange={(event) =>
                          handleChange(
                            item,
                            row.auctionItemDetailId,
                            item.columnTypeId,
                            event.target.value,
                            "columnValue"
                          )
                        }
                        onFocus={(event) => {
                          if (event.target.value === "0") {
                            event.target.value = "";
                          }
                        }}
                        onBlur={(event) => {
                          if (event.target.value === "") {
                            event.target.value = "0";
                          }
                        }}
                        value={item.columnValue}
                        disabled
                      />
                    ) : item.columnTypeId === 33 ? (
                      <input
                        type="number"
                        id={row.auctionItemDetailId}
                        onChange={(event) =>
                          handleChange(
                            item,
                            row.auctionItemDetailId,
                            item.columnTypeId,
                            event.target.value,
                            "columnValue"
                          )
                        }
                        onFocus={(event) => {
                          if (event.target.value === "0") {
                            event.target.value = "";
                          }
                        }}
                        onBlur={(event) => {
                          if (event.target.value === "") {
                            event.target.value = "0";
                          }
                        }}
                        value={item.columnValue}
                        disabled
                      />
                    ) : item.columnTypeId === 32 ? (
                      <input
                        type="number"
                        id={row.auctionItemDetailId}
                        onChange={(event) =>
                          handleChange(
                            item,
                            row.auctionItemDetailId,
                            item.columnTypeId,
                            event.target.value,
                            "columnValue"
                          )
                        }
                        value={item.columnValue}
                        onFocus={(event) => {
                          if (event.target.value === "0") {
                            event.target.value = "";
                          }
                        }}
                        onBlur={(event) => {
                          if (event.target.value === "") {
                            event.target.value = "0";
                          }
                        }}
                        disabled={
                          userWiseViewEnglishAuctionData?.userStatus == 2 ? true :
                          row.isBQEnable == 0
                            ? true
                            : userWiseViewEnglishAuctionData?.cstatus == 6
                            ? true
                            : false
                        }
                      />
                    ) : item.columnTypeId === 34 ||
                      item.columnTypeId === 35 ||
                      item.columnTypeId === 36 ? (
                      <input
                        disabled={
                          userWiseViewEnglishAuctionData?.userStatus == 2 ? true :
                          userWiseViewEnglishAuctionData?.cstatus == 6
                            ? true
                            : false
                        }
                        type="number"
                        id={row.auctionItemDetailId}
                        onFocus={(event) => {
                          if (event.target.value === "0") {
                            event.target.value = "";
                          }
                        }}
                        onBlur={(event) => {
                          if (event.target.value === "") {
                            event.target.value = "0";
                          }
                        }}
                        onChange={(event) =>
                          handleChange(
                            item,
                            row.auctionItemDetailId,
                            item.columnTypeId,
                            event.target.value,
                            "columnValue"
                          )
                        }
                        value={item.columnValue}
                      />
                    ) : item.columnTypeId === 37 ? (
                      <div className="BtnGroup d-flex justify-space-even">
                        <button
                          disabled={
                            userWiseViewEnglishAuctionData?.userStatus == 2 ? true :
                            item.columnStatus == "Sold" || item.columnStatus == "Un sold" || status == "Sold" || status == "Un sold" ? true :
                            userWiseViewEnglishAuctionData?.cstatus == 6
                              ? true
                              : false
                          }
                          onClick={() => handleButton("0", item, row)}
                        >
                          {item.columnValue}
                        </button>
                      </div>
                    ) : item.columnTypeId === 38 ? (
                      <div className="BtnGroup d-flex justify-space-even">
                        <button
                          disabled={
                            statusColor == "custom_TURQUOISE" ? true :
                            userWiseViewEnglishAuctionData?.userStatus == 2 ? true :
                            item.columnStatus == "Sold" || item.columnStatus == "Un sold" || status == "Sold" || status == "Un sold" ? true :
                            row.isEnable == 0
                              ? true
                              : userWiseViewEnglishAuctionData?.cstatus == 6
                              ? true
                              : false
                          }
                          onClick={() => handleButton("1", item, row)}
                        >
                          {item.columnValue}
                        </button>
                      </div>
                    ) : item.columnTypeId == 10 || item.columnTypeId == 11 ? (
                      item.columnValue == 0 ? (
                        ""
                      ) : (
                        <p
                          onClick={() =>
                            handleSelectRow(row.auctionItemDetailId)
                          }
                        >
                          {item.columnValue}
                        </p>
                      )
                    ) : item.columnTypeId == 50 ? (
                      item.columnValue == 0 ? (
                        ""
                      ) : (
                        <p
                          onClick={() =>
                            handleSelectRow(row.auctionItemDetailId)
                          }
                        >
                          {item.columnValue}
                        </p>
                      )
                    ) : item.columnTypeId === 1 ? (
                      <>
                        <p
                          onClick={() =>
                            handleSelectRow(row.auctionItemDetailId)
                          }
                          className="MarketDepth1"
                        >
                           {(rightsIdData && rightsIdData?.length && 
                        rightsIdData?.length > 0 &&
                        rightsIdData?.includes("87")) ?
                          <span
                            onClick={(e) => {
                              e.stopPropagation();
                              handleMarketDepth(row.auctionItemDetailId);
                            }}
                            className="MarketDepth fa fa-line-chart"
                          ></span>
                          : ""}
                          {item.columnValue}
                        </p>
                      </>
                    ) :  item.columnTypeId === 13 ? (
                      <p
                        onClick={() => handleSelectRow(row.auctionItemDetailId)}
                      >
                      {row.isShowRP == 1 ? (item.columnValue) : "   "}
                      </p>
                    ) : (
                      <p
                        onClick={() => handleSelectRow(row.auctionItemDetailId)}
                      >
                        {item.columnValue}
                      </p>
                    )}
                  </td>
                ) : (
                  ""
                )
              )}
          </tr>
        ))}
    </table>
  );
};
export default EnglishTable;
